import {AdobePushData, ErrorLog, ErrorLogs, GmUnified, MakePartial} from '../interface';

export class AdobeDataLayerBaseCall {
    static _generalmotors = {} as MakePartial<AdobePushData>;

    /**
     * @param obj new AdobePushData object to set
     * @param window window object passed in for static manipulation
     * @returns void
     * @description this function sets the _generalmotors object to the new object passed in
    */
    static async setGmUnifiedProperty (obj: MakePartial<AdobePushData>, window: Window) {
        AdobeDataLayerBaseCall._generalmotors = {... obj};
        if(Object.keys(AdobeDataLayerBaseCall._generalmotors)[0] as keyof AdobePushData === 'errorLog'){
            AdobeDataLayerBaseCall._generalmotors = await AdobeDataLayerBaseCall.updateError(obj, window);
        }
        const gmUnifiedObj = {
            _generalmotors: AdobeDataLayerBaseCall._generalmotors
        } as GmUnified;
        window.adobeDataLayer.push(gmUnifiedObj);

    }
    /**
     * @returns void
     * @param event name of event to fire
     * @param window window object passed in for static manipulation
     * @description this function pushes an event to the adobeDataLayer
     */
    static fireDataLayerEvent(event:string,window:Window){
        window.adobeDataLayer.push({event});
    }

    /**
     * @param window: Window
     * @returns Promise<MakePartial<AdobePushData>>
     * @example const gmUnified = await AdobeDataLayerBaseCall.getGmUnifiedProperty(window);
     * @description this function creates a promise in the form of an interval that waits
     * for the window.adobeDataLayer.getState() function to be defined and for the _generalmotors
     * object to defined. Only then can a consumer get current relevant data.
    */
    static getGmUnifiedProperty =(window:Window)=>
        new Promise<MakePartial<AdobePushData>>(resolve => {
            const interval = setInterval(() => {
                const {getState} = window.adobeDataLayer;
                if (typeof getState === 'function' && window.adobeDataLayer.getState()._generalmotors) {
                    clearInterval(interval);
                    resolve(window.adobeDataLayer.getState()._generalmotors);
                }
        },1000);
    }); 
  
    static async updateError(obj: MakePartial<AdobePushData>, window: Window){
        const newError: MakePartial<AdobePushData> = {... obj};
        const currentState = await this.getGmUnifiedProperty(window);

        const errorArray: ErrorLog[] = currentState['errorLog' as keyof AdobePushData] ? currentState['errorLog' as keyof AdobePushData] : [];
        errorArray.push(newError as ErrorLog);
        return {errorLog : errorArray} as ErrorLogs;
    }
}
